import { DB, ExecuteResult, Result, ResultOK } from '../db';
import { Connection } from './connection';
import { SyncRunable } from './sync';
import log from '../log';
import Context from './context';
import { MQ, MQEventCallBack, MQEventData, MQEventType } from './mq';
import TopicController, { TopicCreateBody, TopicProps, TopicWithSummary } from './topic';
import UserController from './user';
import { User, UserModifyCond } from '../db/t_user';
import { Msg, MsgQryCond, MsgSearchCond } from '../db/t_msg';
import MsgController from './msg';
import { config_get, config_get_by_val, config_set } from '../db/t_config';
import Mutext from '../sync/mutext';
import { CacheController } from './cache';
import { AppController } from './app';
import { App } from '../db/t_app';
import { Group } from '../db/t_group';
import { GroupController } from './group';
import { GroupMember } from '../db/t_group_member';
import ContactController from './contact';
import { UserRef, UserRefQryCond } from '../db/t_user_ref';
import { Topic ,topic_modify,topic_update_msg_synced} from '../db/t_topic';
import { GroupSummary, GroupSummaryUpdateType } from '../db/t_group_summary';
import { FriendBlackController } from './friend_black';
import { FriendBlack } from '../db/t_friend_black';
import { Str_SwitchUserFail } from '../../src/language/string_res';
import EmoticonController from './emoticon';
import { Emoticon } from '../db/t_emoticon';
import { LabelGroupedData, Label } from '../db/t_label';
import LabelController from './label';
import { Auth, auth_insert, clear_auths, del_auths, qry_all_auth, qry_auth } from '../db/t_auth';
import TranslateController from './translate';
import packageJson from '../../package.json';
import { AttachConfigResponse } from '../../src/net/response';
import { UploadKey } from '../../src/utils/ReactBlobUtil';
import { LoginDevice, TenantSettings } from '../db/t_user_devices';
import { buildSingleTopicId } from '../../src/utils/helper';
import { getUid } from '../../src/store/token';
import { SystemTopic } from '../../src/screen/Chat/CListItem';
import { attachConfig } from '../../src/net/service';


const env: Env = (packageJson.env as Env) ?? "prod";
// 明确类型，避免使用 string 索引导致的 TS 报错
type Env = 'dev' | 'test' | 'prod';
type Hosts = { api: string; invite: string; sync: string; };

const config: Record<Env, Hosts> = {
	dev: {
		api: '', // 这个是普通请求的,可能会在invite成功后修改
		invite:'', /// 这个是拉取配置的,当前不需要修改,以后可能会修改
		sync: '', // 消息同步接口, 会在invite成功后修改
	},
	test:{
		api: '', // 这个是普通请求的,可能会在invite成功后修改
		invite:'', /// 这个是拉取配置的,当前不需要修改,以后可能会修改
		sync: '', // 消息同步接口, 会在invite成功后修改
	},
	prod: {
		// 后面改为域名
		api: '', // 这个是普通请求的,可能会在invite成功后修改
		invite: '', /// 这个是拉取配置的,当前不需要修改,以后可能会修改
		sync: '', // 消息同步接口, 会在invite成功后修改
		// api: 'http:getaway.mudmguag128bvnaru.xyz:3000',
		// sync: 'http:getaway.mudmguag128bvnaru.xyz:30001',
	},
};

export const isDev = process.env.NODE_ENV === 'development'
// 获取 Miso 模式
export const isMiso = process.env.MISO_MODE;
// 获取应用名称
export const appName = process.env.APP_NAME;

export const appBundleId = process.env.BUNDLE_ID;

export const config_pclogin_proxy_host = () => "/sapi";
export const config_api_proxy_host = () => "/tapi";
export const config_sync_proxy_host = () => "/tsync";

export const config_app_is_miso = () => isMiso;
export const config_api_host = () => config[env].api;
export const config_invite_host = () => config[env].invite;
export const config_sync_host = () => config[env].sync;

export const fixRemoteUrl = (url: string) => {
	if (!url
		|| url.length <= 0
		|| url.startsWith('http')
		|| url.startsWith('file://')
		|| url.startsWith('asset://')
		|| url.startsWith('content://')
		|| url.startsWith('ftp://')
		|| url.startsWith('data:')
	) {
		return url;
	} else {
		// 去除端口号
		const baseUrl = config_api_host().replace(/:\d+(?=\/|$)/, '');
		return '/' + url;
	}
};


export type KKAuth = {
	uid: number;
	token: string;
	appkey: string;
	vcode: string;
	customerServiceUrl: string; //客服入口
	secret: string; //密钥
	encrypt: number; //是否加密 1-加密 其余不加密
	msgAssistant: number; //是否开启群发助手，0-不开启，1-开启
	msgTranslate: number; //是否开启翻译助手，0-不开启，1-开启
} & TenantSettings;

export const defKKAuth: KKAuth = {
	uid: 0,
	token: '',
	appkey: '',
	secret: '',
	encrypt: 0,
	msgAssistant: 0,
	msgTranslate: 0,
	customerServiceUrl: '',
	vcode: '',
};

class API {
	// API类自己独享使用
	private globalMQ: MQ; // 全局事件
	private readonly globalDB: DB; // 全局的库，大家共享的
	private is_init: boolean = false; // 是否已经初始化
	private initMutext: Mutext = new Mutext(); // 锁防止init同时多次调用导致数据库二次创建

	// 用户的的给其它地方使用
	private userContext: Context | undefined;
	private syncRunable: SyncRunable | undefined; // 同步对象
	// controller
	private topicController: TopicController = new TopicController();
	// private userController: UserController = new UserController();
	// private msgController: MsgController = new MsgController();
	// private groupController: GroupController = new GroupController();
	private cacheController: CacheController = new CacheController(); //
	private mediaLimitConfig: AttachConfigResponse | undefined = undefined; // 媒体文件限制配置


	constructor() {
		this.globalMQ = new MQ();
		const appName = config_app_is_miso() ? "db_miso" : "db_hive"
		this.globalDB = new DB(`${appName}_global.db`);
	}

	public global_on(evt: MQEventType, callback: MQEventCallBack) {
		this.globalMQ.on(evt, callback);
	}

	public global_off(evt: MQEventType, callback: MQEventCallBack) {
		this.globalMQ.off(evt, callback);
	}

	public global_emit(evt: MQEventType, data: MQEventData) {
		this.globalMQ.emit(evt, data);
	}

	public on(evt: MQEventType, callback: MQEventCallBack) {
		if (this.userContext) {
			this.userContext.mq.on(evt, callback);
		}
	}

	public off(evt: MQEventType, callback: MQEventCallBack) {
		if (this.userContext) {
			this.userContext.mq.off(evt, callback);
		}
	}

	public emit(evt: MQEventType, data: MQEventData) {
		if (this.userContext) {
			this.userContext.mq.emit(evt, data);
		}
	}

	public setMediaLimitConfig(config: AttachConfigResponse) {
		this.mediaLimitConfig = config;
		if (config) {
			config_set(this.globalDB, 'media_limit_config', JSON.stringify(config)).then(() => {
				log.info('set media_limit_config success');
			}).catch((err) => {
				log.error('set media_limit_config failed:', err);
			});
		}
	}

	public getMediaLimitConfig(): AttachConfigResponse | undefined {
		return this.mediaLimitConfig;
	}

	public getMediaLimit(screen: UploadKey, mimeType: string): number {
		if (this.mediaLimitConfig) {
			const config = this.mediaLimitConfig[screen as keyof AttachConfigResponse];
			if (config) {
				const item = config.find(v => {
					const exts = v.exts;
					for (const ext of exts) {
						if (mimeType.includes(ext)) {
							return true;
						}
					}
					return false;
				});
				if (item) {
					console.log(`🔄 [App] Upload File Size Limit: ${item.maxkb * 1024}, mimeType: ${mimeType}`)
					return item.maxkb * 1024;
				}
			}
		}

		console.log(`🔄 [App] Upload File Size Limit: 0, mimeType: ${mimeType}`)
		return 0; // 缺少数据
	}

	public BuildMinMid(tid: string): string {
		return tid + ':++++++++';
	}

	// 获取缓存信息
	public SetCache(key: string, val: any) {
		return this.cacheController.Set(key, val);
	}

	// 清除所有缓存
	public ClearCache() {
		this.cacheController.Clear();
	}

	// 设置缓存
	public GetCache(key: string): any {
		return this.cacheController.Get(key);
	}

	// 设置消息已读
	public async MsgRead(mids: { mid: string; sender: number }[]): Promise<{ error: any; reportMids?: string[] }> {
		if (this.userContext) {
			return await MsgController.Read(this.userContext, mids);
		}
		return { error: null };
	}

	// 获取消息
	public async GetMsg(cond: MsgQryCond): Promise<{ error: any; msgs?: Msg[] }> {
		if (this.userContext) {
			return MsgController.QryByCond(this.userContext, cond);
		}
		return { error: null };
	}

	// 获取消息
	public async QueryMsg(
		search: string,
		time: number,
		tids?: string[]
	): Promise<{
		error: any;
		data?: { tid: string; total: number }[];
	}> {
		if (this.userContext) {
			return MsgController.Query(this.userContext, search, time, tids);
		}
		return { error: null };
	}

	// 获取消息
	public async SearchMsg(cond: MsgSearchCond): Promise<{ error: any; msgs?: Msg[] }> {
		if (this.userContext) {
			return MsgController.QryBySearch(this.userContext, cond);
		}
		return { error: null };
	}

	// 获取消息
	public async QrySendingMsg(tid: string, cid: number, sender: number): Promise<{ error: any; msgs?: Msg[] }> {
		if (this.userContext) {
			return MsgController.QrySendingMsg(this.userContext, tid, cid, sender);
		}
		return { error: null };
	}

	// 清除消息
	public async CleanMsg(tid: string, mid?: string): Promise<{ code: any }> {
		if (this.userContext) {
			return MsgController.CleanById(this.userContext, tid, mid);
		}
		return { code: -1 };
	}

	public async DelTopic(tid: string): Promise<{ code: any }> {
		if (this.userContext) {
			return TopicController.DelTopic(this.userContext, tid);
		}
		return { code: -1 };
	}

	public async UpsetMsg(uid: number, msg: Msg): Promise<{ error: any }> {
		if (this.userContext) {
			return MsgController.UpsetMsg(this.userContext, uid, msg);
		}
		return { error: -1 };
	}

	public async DelMsgByCid(tid: string, cid: number, mid: string, sender: number): Promise<{ code: any }> {
		if (this.userContext) {
			return MsgController.DelMsgByCid(this.userContext, tid, cid, mid, sender);
		}
		return { code: -1 };
	}

	public async DelMsg(tid: string, msgs: { mid: string; cid: number }[]): Promise<{ code: any }> {
		if (this.userContext) {
			return MsgController.DelMsg(this.userContext, tid, msgs);
		}
		return { code: -1 };
	}

	public async QryLatest(tid: string): Promise<{ error: any; msgs?: Msg[]; overlap?: boolean; oldestMid?: string }> {
		if (this.userContext) {
			return MsgController.QryLatest(this.userContext, tid);
		}
		return { error: -1 };
	}

	public async QryMsgRemote(tid: string, body: any): Promise<{ error: any; msgs?: Msg[]; overlap?: boolean; oldestMid?: string }> {
		if (this.userContext) {
			return MsgController.QryMsgRemote(this.userContext, tid, body);
		}
		return { error: -1 };
	}

	// 更新会话消息桥接状态
	public async UpdateTopicBridgeState(
		tid: string,
		bridge: {
			msg_synced?: number;
			bridgeState?: number;
			bridgeCursor?: string;
			bridgePages?: number;
			bridgeEpoch?: number;
			bridgeUpdatedAt?: number;
		}
	): Promise<void> {
		if (this.userContext) {
			await topic_modify(this.userContext.db, {
				tid,
				msg_synced: bridge.msg_synced,
				bridgeState: bridge.bridgeState,
				bridgeCursor: bridge.bridgeCursor,
				bridgePages: bridge.bridgePages,
				bridgeEpoch: bridge.bridgeEpoch,
				bridgeUpdatedAt: bridge.bridgeUpdatedAt,
			});
		}
	}

	// 清除消息
	public async CleanAllMsg(): Promise<{ code: any }> {
		if (this.userContext) {
			const res = await MsgController.QryAllMsgTids(this.userContext);
			// const res = await Promise.all([this.GetTopicList("top"), this.GetTopicList("normal")])
			// const [top, normal] = res
			// const topic = [...(top.topics ?? []), ...(normal.topics ?? [])]
			// const length = topic.length;
			// const body: { tid: string, mid: string }[] = []
			// for (let i = 0; i < length; i++) {
			//     const element = topic[i];
			//     const tid = element.topic.tid;
			//     const mid = element.summary?.latest?.mid ?? '';
			//     if (tid.length > 0 && mid.length > 0) {
			//         body.push({ tid: tid, mid: mid })
			//     }
			// }
			// if (body.length > 0) {
			//     return MsgController.CleanAllMsg(this.userContext, { delete_infos: body });
			// } else {
			//     return { code: 1 }
			// }
			if (res.tids && res.tids.length > 0) {
				const tid = buildSingleTopicId(SystemTopic.Collect, getUid());
				const tids = res.tids.filter(item => item.tid !== tid); // 过滤掉临时会话
				return MsgController.CleanAllMsg(this.userContext, { delete_infos: tids });
			} else {
				return { code: 1 };
			}
		}
		return { code: -1 };
	}

	// 查询通讯录信息
	public async GetContact(cond: UserRefQryCond): Promise<{
		error: any;
		refs?: UserRef[];
		users?: User[];
	}> {
		if (this.userContext) {
			return await ContactController.Get(this.userContext, cond);
		}
		return { error: null };
	}

	// 查询通讯录信息
	public async GetRemoteContact(): Promise<{
		error: any;
		users?: User[];
	}> {
		if (this.userContext) {
			return await ContactController.GetRemote(this.userContext);
		}
		return { error: null };
	}

	//查询黑名单
	public async GetFriendBlack(): Promise<{ error: any; blacks?: FriendBlack[] }> {
		if (this.userContext) {
			return await FriendBlackController.query_blacks(this.userContext);
		}
		return { error: null };
	}

	//查询黑名单
	public async GetRemoteFriendBlack(): Promise<{ error: any; blacks?: FriendBlack[] }> {
		if (this.userContext) {
			return await FriendBlackController.do_refresh_black(this.userContext);
		}
		return { error: null };
	}

	//设置黑名单
	public async SetFriendBlack(uid: number, black: string): Promise<{ error: any; result?: ExecuteResult }> {
		if (this.userContext) {
			const r = await FriendBlackController.update_blacks(this.userContext, uid, black);
			return { error: 0, result: r };
		}
		return { error: null };
	}

	// 批量获取同步接口本地没有保证到服务器查
	public async GetUserMuti(uids: number[], sync: boolean = false): Promise<{ error: any; users?: User[] }> {
		if (this.userContext) {
			const r = await UserController.GetMuti(this.userContext, uids, sync);
			return r;
		}
		return { error: null };
	}

	// 本地没有先返回空然后异步到服务器查 然后事件回调
	public async GetUser(uid: number, sync: boolean = false): Promise<{ error: any; user?: User }> {
		if (this.userContext) {
			return await UserController.Get(this.userContext, uid, sync);
		}
		return { error: null };
	}

	// 本地没有先返回空然后异步到服务器查 然后事件回调
	public async UserModify(cond: UserModifyCond): Promise<ExecuteResult> {
		if (this.userContext) {
			return await UserController.UserModify(this.userContext, cond);
		}
		return { error: null, rowsAffected: 0, insertId: 0 };
	}

	// 本地没有先返回空然后异步到服务器查 然后事件回调
	public async GetUserRemote(uid: number): Promise<{ error: any; users?: User[] }> {
		if (this.userContext) {
			return await UserController.GetRemote(this.userContext, [uid]);
		}
		return { error: null };
	}

	public async GetUsersRemote(uids: number[]): Promise<{ error: any; users?: User[] }> {
		if (this.userContext) {
			return await UserController.GetRemote(this.userContext, uids);
		}
		return { error: null };
	}

	// 群摘要信息， 后续不如把群成员也都返回，就复用一份数据
	public async GetGroupSummaryList(sync: boolean = true): Promise<{
		error: any;
		groupSummarys?: GroupSummary[];
	}> {
		if (this.userContext) {
			return await GroupController.QrySummaryList(this.userContext, sync);
		}
		return { error: null };
	}
	public async GetGroupSummary(tid: string): Promise<{
		error: any;
		groupSummary?: GroupSummary;
	}> {
		if (this.userContext) {
			return await GroupController.QrySummary(this.userContext, tid);
		}
		return { error: null };
	}

	public async GroupSummaryUpdate(tid: string, data: GroupSummaryUpdateType): Promise<{ error: any }> {
		if (this.userContext) {
			return await GroupController.GroupSummaryUpdate(this.userContext, tid, data);
		}
		return { error: null };
	}

	public async SetTopicProps(props: TopicProps): Promise<{ error: any }> {
		if (this.userContext) {
			return await this.topicController.SetProps(this.userContext, props);
		}
		return { error: null };
	}

	public SetDraft(tid: string, draft: string) {
		if (this.userContext) {
			this.topicController.SetDraft(this.userContext, tid, draft).then();
		}
	}

	// 创建会话
	public async CreateTopic(data: TopicCreateBody): Promise<{ error: any; topic?: Topic }> {
		if (this.userContext) {
			return await this.topicController.Create(this.userContext, data);
		}
		return { error: null };
	}

	public async GetTopicDetail(
		tid: string,
		sync: boolean = false, // 本地没有是否同步到远端去查
		isEmit: boolean = true
	): Promise<{ error: any; topic?: TopicWithSummary }> {
		if (this.userContext) {
			return await this.topicController.Detail(this.userContext, tid, sync, isEmit);
		}
		return { error: null };
	}

	// 主动获取会话列表
	// 思路是，立即查询本地数据库，有什么返回什么
	// 但是顺带检查一下上一次同步会话列表是什么时候，
	// 如果超过三天，或者本地没有记录时间，则后台触发同步任务，完成同步后事件通知。
	// 事件通知到业务层后，业务层再次调用本接口获取更新。
	public async GetTopicList(
		type: 'normal' | 'top',
		sync: boolean = false // 本地没有是否同步到远端去查
	): Promise<{
		error: any;
		topics?: TopicWithSummary[];
	}> {
		if (this.userContext) {
			return await this.topicController.GetList(this.userContext, type);
		}
		return { error: null };
	}

	public async GetAllTopicList(
		sync: boolean = false, // 本地没有是否同步到远端去查
		isEmit: boolean = false
	): Promise<{
		isAllRefresh: boolean;
		topTopics?: TopicWithSummary[];
		normalTopics?: TopicWithSummary[];
	}> {
		if (this.userContext) {
			return await this.topicController.GetAllList(this.userContext, sync, isEmit);
		}
		return { isAllRefresh: false };
	}

	public async GetAllTopicListRemote(): Promise<void> {
		if (this.userContext) {
			return await this.topicController.GetAllListRemote(this.userContext);
		}
	}
	public GetGlobalDB(): DB {
		return this.globalDB;
	}

	public GetUserDB(): DB | undefined {
		return this.userContext?.db;
	}

	// 初始化
	public async init(): Promise<Result> {
		if (this.is_init) {
			log.info('api ardady init');
			return ResultOK;
		}

		await this.initMutext.Lock();
		if (this.is_init) {
			this.initMutext.UnLock();
			log.info('api ardady init');
			return ResultOK;
		}
		const r = await this.globalDB.Open();
		if (!r.error) {
			this.is_init = true;

			config_get(this.globalDB, 'media_limit_config').then((res) => {
				if (res.data && res.data.val) {
					const d = JSON.parse(res.data.val);
					this.mediaLimitConfig = d as AttachConfigResponse;
				}
			});

		}
		this.initMutext.UnLock();

		return r.error ? r : ResultOK;
	}

	// 获得上一次登陆缓存着的用户
	public async GetLastAuth(): Promise<KKAuth> {
		const r1 = await config_get(this.globalDB, 'auth');
		if (r1.data && r1.data.val) {
			const d = JSON.parse(r1.data.val);
			return d as KKAuth;
		}
		return defKKAuth;
	}

	public async SetLastAuth(auth: KKAuth) {
		await config_set(this.globalDB, 'auth', JSON.stringify(auth));
	}

	// public setBaseUrl(val: string) {
	// 	config[env].api = val;
	// }

	// public getBaseUrl(): string {
	// 	return config[env].api;
	// }

	// public setBaseSyncUrl(val: string) {
	// 	config[env].sync = val;
	// }

	public async getAuths(): Promise<{ error?: any; auths?: (KKAuth & Auth)[] }> {
		/* public async getAuths(uid: number): Promise<{ error?: any; auths?: (KKAuth & Auth)[] }> {
			const r = await qry_qh_auth(this.globalDB, uid);
			if (!r || !r.uids || r.uids.length == 0) {
				return { error: r.error };
			}
			const uids = new Set<number>();
			r.uids.forEach((value) => {
				uids.add(value.uidA);
				uids.add(value.uidB);
			});
			const r1 = await qry_auth(this.globalDB, Array.from(uids));
			return { error: r1.error, auths: r1.auths }; */
		return await qry_all_auth(this.globalDB)
	}

	public async getAuth(uid: number): Promise<{ error?: any; auth?: KKAuth }> {
		const r1 = await qry_auth(this.globalDB, uid);
		if (r1.auths && r1.auths.length > 0) {
			return { error: r1.error, auth: r1.auths[0] };
		}
		return { error: r1.error };
	}

	/* public async insertAuth(auth: KKAuth & Auth, lastUid: number) {
		const qid = getQhId(auth.uid, lastUid);
		const promise1 = auth_qh_insert(this.globalDB, { qhId: qid, uidA: auth.uid, uidB: lastUid });
		const promise2 = auth_insert(this.globalDB, auth);
		if (auth.uid !== lastUid) {
			const qid = getQhId(auth.uid, auth.uid);
			const promise3 = auth_qh_insert(this.globalDB, { qhId: qid, uidA: auth.uid, uidB: auth.uid });
			return await Promise.all([promise1, promise2, promise3]);
		} else {
			return await Promise.all([promise1, promise2]);
		}
	} */

	public async insertAuth(auth: KKAuth & Auth,) {
		return await auth_insert(this.globalDB, auth);
	}

	/* public async delAuths(uid: number, delUid: number) {
		const promise1 = del_auths(this.globalDB, delUid);
		const promise2 = del_qh_auth(this.globalDB, uid, delUid);
		return await Promise.all([promise1, promise2]);
	} */
	public async delAuths(delUid: number) {
		return del_auths(this.globalDB, delUid);
	}

	public async clearAuths() {
		return clear_auths(this.globalDB);
	}

	// 当前的使用的用户uid
	public CurrentUid(): number {
		if (this.userContext) {
			return this.userContext.uid;
		}
		return 0;
	}

	// 当前的使用的用户uid
	public CurrentAppkey(): string {
		if (this.userContext) {
			return this.userContext.appkey;
		}
		return '';
	}

	public async ClearDatabase(): Promise<Result> {
		const r = await config_get_by_val(this.globalDB, 'user_db_name');
		if (r.error) {
			return { error: r.error };
		}
		if (r.data && r.data.length > 0) {
			for (let i = 0; i < r.data.length; i++) {
				await DB.DropDatabase(r.data[i].key);
			}
		}
		return { error: null };
	}

	public async LocalUids(): Promise<{ error: any; uidList?: number[] }> {
		const prefix = `kk${env}`;
		const r = await config_get_by_val(this.globalDB, 'user_db_name');
		if (r.error) {
			return { error: r.error };
		}
		if (r.data && r.data.length > 0) {
			const uids: number[] = [];
			r.data.forEach((v) => {
				if (v.key.startsWith(prefix)) {
					// console.log('是当前环境', v.key);
					const n = parseInt(v.key.slice(prefix.length, -3), 10);
					if (!isNaN(n)) {
						// if ( n != NaN) {
						uids.push(n);
					}
				} else {
					// console.log('非当前环境', v.key);
				}
			});
			return { error: null, uidList: uids };
		}
		return { error: null, uidList: [] };
	}

	// 切换用户
	public async SwitchUser(auth: KKAuth): Promise<Result> {
		console.log('🔄 [SwitchUser] 开始切换用户, uid:', auth.uid, 'token:', auth.token ? '有' : '无');
		log.info('🔄 [SwitchUser] 开始切换用户', { uid: auth.uid, hasToken: !!auth.token });
		
		// 异常检查
		if (auth.uid < 0) {
			console.error('❌ [SwitchUser] uid 无效:', auth.uid);
			return { error: Str_SwitchUserFail };
		}

		// 相同的用户直接成功
		if (this.userContext && this.userContext.uid === auth.uid) {
			console.log('✅ [SwitchUser] 相同用户，直接返回成功, uid:', auth.uid);
			return ResultOK;
		}

		// 清除缓存的数据
		await config_set(this.globalDB, 'auth', '');
		this.cacheController.Clear();
		ContactController.Clear(); //  可能还是不用static好点
		TopicController.Clear(); // 可能还是不用static好点
		MsgController.Clear();

		// 清理sync
		if (this.syncRunable) {
			this.syncRunable.Destory();
			this.syncRunable = undefined;
		}

		// 执行清理
		if (this.userContext) {
			await this.userContext.mq.Close();
			await this.userContext.db.Close();
			await this.userContext.conn.Close();
			this.userContext = undefined;
		}

		// 不切换用户
		if (auth.uid === 0) {
			console.log('ℹ️ [SwitchUser] uid 为 0，不切换用户');
			return ResultOK;
		}

		const appName = config_app_is_miso() ? "db_miso" : "db_hive"
		const userDbName = `kk${appName}${env}${auth.uid}.db`;
		console.log('📦 [SwitchUser] 准备打开用户数据库:', userDbName);
		
		// 记录下打开过的用户，方便后面删除
		const r0 = await config_set(this.globalDB, userDbName, 'user_db_name');
		if (r0.error) {
			console.error('❌ [SwitchUser] 保存用户数据库名称失败:', r0.error);
			return { error: r0.error };
		}

		// 打开用户数据库
		console.log('📦 [SwitchUser] 正在打开数据库:', userDbName);
		const db = new DB(userDbName);
		const r = await db.Open();
		if (r.error) {
			console.error('❌ [SwitchUser] 打开数据库失败:', r.error);
			return r;
		}
		console.log('✅ [SwitchUser] 数据库打开成功');

		const mq = new MQ();
		// 切换用户成功,需要改变当前用户的配置域名信息
		const conn = new Connection(mq);
		conn.SetAuth(auth);

		// 初始化Context
		const ctx = new Context(auth, db, conn, mq);
		this.userContext = ctx;

		// 初始化sync
		console.log('🔄 [SwitchUser] 创建 SyncRunable 并启动');
		this.syncRunable = new SyncRunable(ctx);
		console.log('🔄 [SwitchUser] 调用 syncRunable.Run()');
		this.syncRunable.Run();
		console.log('✅ [SwitchUser] syncRunable.Run() 调用完成');

		// 记录下登陆的用户，用于下次使用
		await config_set(this.globalDB, 'auth', JSON.stringify(auth));
		console.log('✅ [SwitchUser] 切换用户成功, uid:', auth.uid);
		log.info('✅ [SwitchUser] 切换用户成功', { uid: auth.uid });
		return ResultOK;
	}

	// 获取应用信息
	public async GetMyAppSync(): Promise<{ error: any; app?: App }> {
		if (this.userContext) {
			return await this.GetAppSync(this.userContext.appkey);
		}
		return { error: null };
	}

	// 获取应用信息
	public async GetAppSync(appkey: string): Promise<{ error: any; app?: App }> {
		if (this.userContext) {
			return await AppController.QryOneSync(this.userContext, appkey);
		}
		return { error: null };
	}

	public async GroupUpsert(group: Group) {
		if (this.userContext) {
			return await GroupController.GroupUpsert(this.userContext, group);
		}
		return { error: null };
	}

	public async GroupUserModify(user: User) {
		if (this.userContext) {
			return await GroupController.GroupUserModify(this.userContext, user);
		}
		return { error: null };
	}

	public async GroupUserRemarkModify(uid: number, remark: string) {
		if (this.userContext) {
			return await GroupController.GroupUserRemarkModify(this.userContext, uid, remark);
		}
		return { error: null };
	}

	public async QryGroupTidsByUid(uid: number): Promise<{ error: any; tids?: string[] }> {
		if (this.userContext) {
			return await GroupController.QryGroupTidsByUid(this.userContext, uid);
		}
		return { error: null };
	}

	// 从远程获取
	public async GetGroupRemote(
		tid: string,
		oldGroup?: Group
	): Promise<{
		error: any;
		group?: Group;
		members?: GroupMember[];
	}> {
		if (this.userContext) {
			const r = await GroupController.GetRemote(this.userContext, tid, oldGroup);
			return r;
		}
		return { error: null };
	}

	// 获取群信息，默认取本地，异步远程更新
	public async GetGroupDetail(
		tid: string,
		sync: boolean = false
	): Promise<{
		error: any;
		group?: Group;
		members?: GroupMember[];
	}> {
		if (this.userContext) {
			return await GroupController.Detail(this.userContext, tid, sync);
		}
		return { error: null };
	}

	// 获取群信息，默认取本地，异步远程更新
	public async QryGroupMembersDetail(tid: string): Promise<{
		error: any;
		members?: GroupMember[];
	}> {
		if (this.userContext) {
			return GroupController.QryGroupMembersDetail(this.userContext, tid);
		}
		return { error: null };
	}

	//获取收藏的表情
	public async GetEmoticonList(skip: number, pageSize: number): Promise<{ error?: any; emoticons?: Emoticon[] }> {
		if (this.userContext) {
			return EmoticonController.GetEmoticon(this.userContext, skip, pageSize);
		}
		return { error: null };
	}

	//删除收藏的表情
	public async DelEmoticon(ids: string[]): Promise<{ error?: any }> {
		if (this.userContext) {
			return EmoticonController.DelEmoticon(this.userContext, ids);
		}
		return { error: null };
	}

	//添加收藏的表情
	public async AddEmoticon(url: string): Promise<{ error?: any; emoticon?: Emoticon }> {
		if (this.userContext) {
			return EmoticonController.AddEmoticon(this.userContext, url);
		}
		return { error: null };
	}

	//标签相关
	public async GetAllLabels(): Promise<{ error?: any; labels?: LabelGroupedData[] }> {
		if (this.userContext) {
			return LabelController.GetAllLabels(this.userContext);
		}
		return { error: null };
	}

	public async GetLabels(
		skip: number,
		pageSize: number,
		search?: string
	): Promise<{
		error?: any;
		labels?: LabelGroupedData[];
	}> {
		if (this.userContext) {
			return LabelController.GetLabels(this.userContext, skip, pageSize, search);
		}
		return { error: null };
	}

	public async GetLabelsByUid(uid: number): Promise<{ error?: any; labels?: { label: string }[] }> {
		if (this.userContext) {
			return LabelController.QryLabelsByUid(this.userContext, uid);
		}
		return { error: null };
	}

	public async GetLabel(label: string): Promise<{ error?: any; labels?: { label: string }[] }> {
		if (this.userContext) {
			return LabelController.QryLabel(this.userContext, label);
		}
		return { error: null };
	}

	//标签相关
	public async GetLabelsRemote(
		skip: number,
		pageSize: number
	): Promise<{
		error?: any;
		labels?: LabelGroupedData[];
	}> {
		if (this.userContext) {
			return LabelController.GetRemote(this.userContext, skip, pageSize);
		}
		return { error: null };
	}

	public async DelLabelUids(label: string, uids: number[]): Promise<{ error?: any }> {
		if (this.userContext) {
			return LabelController.DelLabelUids(this.userContext, label, uids);
		}
		return { error: null };
	}

	public async DelLabel(label: string): Promise<{ error?: any }> {
		if (this.userContext) {
			return LabelController.DelLabel(this.userContext, label);
		}
		return { error: null };
	}

	public async DelLabelByUid(uid: number): Promise<{ error?: any }> {
		if (this.userContext) {
			return LabelController.DelLabelByUid(this.userContext, uid);
		}
		return { error: null };
	}
	public async UpdateUser(user: User) {
		if (this.userContext) {
			return LabelController.UpdateUser(this.userContext, user);
		}
		return null;
	}
	public async UpdateLabelRemark(uid: number, remark: string) {
		if (this.userContext) {
			return LabelController.UpdateLabelRemark(this.userContext, uid, remark);
		}
		return null;
	}

	public async UpdateLabelAvator(uid: number, avatar: string) {
		if (this.userContext) {
			return LabelController.UpdateLabelAvatar(this.userContext, uid, avatar);
		}
		return null;
	}
	public async AddLabel(label: string, users: User[], type: 0 | 1): Promise<{ error?: any; labels?: Label[] }> {
		if (this.userContext) {
			return LabelController.AddLabel(this.userContext, label, users, type);
		}
		return { error: null };
	}

	public async UpdateLabel(oldeLabel: string, newLabel: string): Promise<{ error?: any }> {
		if (this.userContext) {
			return LabelController.UpdateLabel(this.userContext, oldeLabel, newLabel);
		}
		return { error: null };
	}

	public async QryTranslate(mid: string, msg: string, to: string, meta: any): Promise<{ error?: any; data?: string }> {
		if (this.userContext) {
			return TranslateController.qryTranslate(this.userContext, mid, msg, to, meta);
		}
		return { error: null };
	}

	public async QryTranslateLocal(mid: string): Promise<{ error?: any; data?: string }> {
		if (this.userContext) {
			return TranslateController.qryTranslateLocal(this.userContext, mid);
		}
		return { error: null };
	}

	public async CancelTranslateLocal(mid: string, meta: any): Promise<{ error?: any }> {
		if (this.userContext) {
			return TranslateController.cancelTranslateLocal(this.userContext, mid, meta);
		}
		return { error: null };
	}

	// 更新消息占位图
	public async updateThumbnailPath(mid: string, thumbnailPath: string): Promise<{ error?: any }> {
		if (this.userContext) {
			return MsgController.updateThumbnailPath(this.userContext, mid, thumbnailPath);
		}
		return { error: null };
	}

	// 更新消息meta内容
	public async updateMsgMeta(mid: string, meta: any): Promise<{ error?: any }> {
		if (this.userContext) {
			return MsgController.updateMsgMeta(this.userContext, mid, meta);
		}
		return { error: null };
	}

	// 查询消息
	public async queryMsg(mid: string): Promise<{ error?: any }> {
		if (this.userContext) {
			return MsgController.queryMsg(this.userContext, mid);
		}
		return { error: null };
	}

	public async queryLoginDevices(): Promise<{ error?: any; devices?: LoginDevice[] }> {
		if (this.userContext) {
			return UserController.queryLoginDevices(this.userContext);
		}
		return { error: null };
	}

	public async updateLoginDevices(): Promise<{ error?: any; devices?: LoginDevice[] }> {
		if (this.userContext) {
			return await UserController.updateLoginDevices(this.userContext);
		}
		return { error: null };
	}

	public async queryFriendApplyNum(): Promise<{ error?: any; friendApplyNum?: number }> {
		if (this.userContext) {
			return UserController.queryFriendApplyNum(this.userContext);
		}
		return { error: null };
	}


	public async updateAttachConfig() {
		if (config_api_host().length === 0 || getUid() === 0) {
			return;
		}
		attachConfig().then((res) => {
			if (res.code !== 0) {
				return;
			}

			if (res.data) {
				// console.log('----> fetch attach config success: ', JSON.stringify(res.data));
				this.setMediaLimitConfig(res.data);
			}
		}).catch((err) => {
			log.error('fetch attach config failed:', err);
		});
	}
	// 标记会话消息已加载过历史
	public async UpdateMsgSynced(tid: string): Promise<void> {
		if (this.userContext) {
			await topic_update_msg_synced(this.userContext.db, tid);
		}
	}

	/** 进入聊天页：本地未读清零并通知列表刷新（与「进会话即视为已读」一致） */
	public async ClearTopicUnreadOnEnter(
		tid: string,
	): Promise<{ topic?: TopicWithSummary }> {
		if (!this.userContext || !tid) {
			return {};
		}
		await topic_modify(this.userContext.db, { tid, unread: 0 });
		const r = await this.topicController.Detail(this.userContext, tid, false, false);
		if (r.topic) {
			this.userContext.mq.emit("topic_qry", {
				topic_qry: { topicDetail: r.topic },
			});
			return { topic: r.topic };
		}
		return {};
	}
	/** 仅读本地库，不打 group/detail、topic/user/detail（搜索等场景避免 N 次远程） */
	public async GetGroupLocal(tid: string): Promise<{
		error: any;
		group?: Group;
		members?: GroupMember[];
	}> {
		if (this.userContext) {
			return await GroupController.QryLocal(this.userContext, tid);
		}
		return { error: null };
	}
}

// 导出
let api: API | null = null;
export const getInstance = (): API => {
	if (api === null) {
		// log.warn('初始化API实例');
		api = new API();
	} else {
		// log.warn('复用API实例');
	}
	return api;
};
